import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminSubscriptionListItem, AdminSubscriptionDetail, AdminUpgradeRequest, AdminDowngradeRequest, AdminCancelRequest, AdminRefundRequest, AdminExtendTrialRequest, AdminOverrideUsageRequest, AdminStatusChangeRequest } from '../types/subscriptions';

export const subscriptionsApi = {
  list: (params: PaginationParams & { status?: string; plan?: string }) =>
    apiClient.get<PaginatedResponse<AdminSubscriptionListItem>>('/subscriptions', { params }).then((r) => r.data),
  detail: (id: string) =>
    apiClient.get<AdminSubscriptionDetail>(`/subscriptions/${id}`).then((r) => r.data),
  upgrade: (id: string, data: AdminUpgradeRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/upgrade`, data).then((r) => r.data),
  downgrade: (id: string, data: AdminDowngradeRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/downgrade`, data).then((r) => r.data),
  cancel: (id: string, data: AdminCancelRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/cancel`, data).then((r) => r.data),
  refund: (id: string, data: AdminRefundRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/refund`, data).then((r) => r.data),
  extendTrial: (id: string, data: AdminExtendTrialRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/extend-trial`, data).then((r) => r.data),
  overrideUsage: (id: string, data: AdminOverrideUsageRequest) =>
    apiClient.post<MessageResponse>(`/subscriptions/${id}/override-usage`, data).then((r) => r.data),
  changeStatus: (id: string, data: AdminStatusChangeRequest) =>
    apiClient.patch<MessageResponse>(`/subscriptions/${id}/status`, data).then((r) => r.data),
};
